/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_RequiredInputs */

const en_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group name is required.`)
};

const fr_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom du groupe est requis.`)
};

const de_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Angabe des Gruppennamens ist erforderlich.`)
};

const it_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nome del gruppo è obbligatorio.`)
};

const ru_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название группы обязательно для заполнения.`)
};

const es_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre del grupo es obligatorio.`)
};

const zh_cn2_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组名称为必填项。`)
};

const ja_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ名は必須です。`)
};

const hi_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह का नाम आवश्यक है।`)
};

const pt_pt2_team_manager_group_name_required = /** @type {(inputs: Team_Manager_Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É necessário nomear o grupo.`)
};

/**
* | output |
* | --- |
* | "Group name is required." |
*
* @param {Team_Manager_Group_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_required = /** @type {((inputs?: Team_Manager_Group_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_name_required(inputs)
	if (locale === "de") return de_team_manager_group_name_required(inputs)
	if (locale === "it") return it_team_manager_group_name_required(inputs)
	if (locale === "ru") return ru_team_manager_group_name_required(inputs)
	if (locale === "es") return es_team_manager_group_name_required(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_name_required(inputs)
	if (locale === "ja") return ja_team_manager_group_name_required(inputs)
	if (locale === "hi") return hi_team_manager_group_name_required(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_name_required(inputs)
	return en_team_manager_group_name_required(inputs)
});